import { useCallback } from 'react';
import {
  GenerateDeviceReportOptions,
  GetHardwareOptions,
  GetJobsStatusOptions,
  trackerClient,
} from '@bymason/controller-api';
import { useGetDataHook } from '@bymason/api-hooks-base';

export {
  HardwareModel,
  JobsStatusModel,
  DeviceBuildModel,
  JobModel,
  BuildResult,
  BuildStatus,
  GenerateDeviceReportResult,
} from '@bymason/controller-api';

/**
 * React hook that asynchronously gets a device project.
 * @returns HookArray
 * @HookArray [0] get method
 * @HookArray [1] result
 * @HookArray [2] error
 * @HookArray [3] busy flag
 * @HookArray [4] error code
 * @HookArray [5] error data
 * @HookArray [6] clearData method
 */
export function useGetHardware(clientToken: string) {
  const handleGetData = useCallback(
    (options: GetHardwareOptions) => {
      return trackerClient.getHardware(options, clientToken);
    },
    [clientToken]
  );

  return useGetDataHook(handleGetData);
}

/**
 * React hook that asynchronously gets a device project.
 * @returns HookArray
 * @HookArray [0] get method
 * @HookArray [1] result
 * @HookArray [2] error
 * @HookArray [3] busy flag
 * @HookArray [4] error code
 * @HookArray [5] error data
 * @HookArray [6] clearData method
 */
export function useGetJobsStatus(clientToken: string) {
  const handleGetData = useCallback(
    (options: GetJobsStatusOptions) => {
      return trackerClient.getJobsStatus(options, clientToken);
    },
    [clientToken]
  );

  return useGetDataHook(handleGetData);
}

/**
 * React hook that initializes device report creation.
 * @returns HookArray
 * @HookArray [0] get method
 * @HookArray [1] result
 * @HookArray [2] error
 * @HookArray [3] busy flag
 * @HookArray [4] error code
 * @HookArray [5] error data
 * @HookArray [6] clearData method
 */
export function useGenerateDeviceReport(clientToken: string) {
  const handleGetData = useCallback(
    (options: GenerateDeviceReportOptions) => {
      return trackerClient.generateDeviceReport(options, clientToken);
    },
    [clientToken]
  );

  return useGetDataHook(handleGetData);
}
